import React from 'react';

interface selectProps {
    children: React.ReactNode;
    value: any;
    onChange: (value: any) => void;
    classList?: string;
    disabled?: boolean;
    required?: boolean;
    id?: string;
}

export default function Select({
    children,
    value,
    onChange,
    classList,
    disabled = false,
    required = false,
    id,
}: selectProps) {
    return (
        <>
            <select
                disabled={disabled}
                required={required}
                className={` bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor text-layout-textcolor rounded-lg outline-none focus:border-primary transition-all duration-100 ${classList} ${
                    disabled ? 'opacity-50 cursor-not-allowed' : ''
                }`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                id={id}
            >
                {children}
            </select>
        </>
    );
}
